import { create } from 'zustand';
import { FileEntry, NodeAccessLevel, RemoteSoftware, RemoteInfection } from '../types';

export interface RemoteSession {
  targetIp: string;
  targetUsername: string;
  targetInternetMbit: number;
  files: FileEntry[];
  accessLevel: NodeAccessLevel;
  software: RemoteSoftware[];
  softwareHidden: boolean;
  infections: RemoteInfection[];
  // Target hardware totals (for the CPU/RAM/HDD bars). Current usage is derived
  // client-side from `software` + `files` so it stays in sync on refresh.
  cpuMhz: number;
  ramMb: number;
  hddMb: number;
}

interface SessionStore {
  session: RemoteSession | null;
  connect:     (s: RemoteSession) => void;
  disconnect:  ()                 => void;
  setFiles:    (files: FileEntry[]) => void;
  setSoftware: (software: RemoteSoftware[], hidden: boolean) => void;
  setInfections: (infections: RemoteInfection[]) => void;
}

export const useSessionStore = create<SessionStore>(set => ({
  session: null,
  connect:     (s)      => set({ session: s }),
  disconnect:  ()       => set({ session: null }),
  setFiles:    (files)  => set(state => state.session ? { session: { ...state.session, files } } : {}),
  setSoftware: (software, hidden) =>
    set(state => state.session ? { session: { ...state.session, software, softwareHidden: hidden } } : {}),
  setInfections: (infections) =>
    set(state => state.session ? { session: { ...state.session, infections } } : {}),
}));
